import { format } from "lib/globalize-util";

export const generateBreadcrumbs = (brandId: string) => [
    {
        url: `/brand/${brandId}/admin/brand`,
        title: format("Brand Admin"),
    },
    {
        url: `/brand/${brandId}/admin/brand?activeTab=promotions`,
        title: format("Promotions"),
    },
    {
        url: `/brand/${brandId}/admin/promotions/list`,
        title: format("List"),
    },
];
